(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Loggrr"] = factory();
	else
		root["Loggrr"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';
	
	var Loggrr = function Loggrr() {
	
	  var settings = void 0;
	  // Default configuration settings
	  var defaults = {
	    // remoteLogging: false,
	    // remoteSettings: {
	    //   url: null,
	    //   params: null,
	    //   success: null,
	    //   error: null
	    // }
	  };
	
	  // Public methods
	  var init = function init() {
	    var userSettings = arguments.length <= 0 || arguments[0] === undefined ? defaults : arguments[0];
	
	    // Override with user config
	    settings = Object.assign(defaults, userSettings);
	    window.addEventListener('error', _listener);
	  };
	
	  // Private methods
	  var _listener = function _listener(e) {
	    // Prevent default error behaviour
	    e.preventDefault();
	
	    _getDetailedError(e);
	    // if (settings.remoteLogging) {
	    //   _remoteLogging(e, settings.remoteSettings);
	    // }
	  };
	
	  var _getDetailedError = function _getDetailedError(e) {
	    // Retreive the error data
	    var data = _errorData(e);
	
	    // Build up help path for stackoverflow
	    var helpPath = encodeURI('https://stackoverflow.com/search?q=' + data.error.split(' ').join('+'));
	
	    var error = ['%cType: ' + data.type, 'Error: ' + data.error, 'Stack Trace: ' + data.stackTrace.replace(/\s+/g, ' '), 'File Name: ' + data.filename, 'Path: ' + data.path, 'Line Number: ' + data.line + '\tColumn: ' + data.column, 'Date: ' + data.datetime, 'Debug: ' + data.path + ':' + data.line, 'Help: ' + helpPath].join('\n');
	
	    console.log(error, 'font-weight: bold;color: #c0392b');
	  };
	
	  // const _checkStatus = (response) => {
	  //   if (response.status >= 200 && response.status < 300) {
	  //     return response
	  //   } else {
	  //     var error = new Error(response.statusText)
	  //     error.response = response
	  //     throw error
	  //   }
	  // }
	
	  // function _parseJSON(response) {
	  //   return response.json()
	  // }
	
	  // function _remoteLogging(e, remoteSettings) {
	  //   if (!remoteSettings.url) {
	  //     throw 'URL Not provided for remote error logging.';
	  //   } else if (remoteSettings.params && typeof remoteSettings.params !== 'object') {
	  //     throw 'Invalid paramaters provided for remote error logging.';
	  //   }
	
	  //   const url = remoteSettings.url;
	  //   const query = Object.keys(params).map((k) => {
	  //     return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
	  //   }).join('&');
	
	  //   fetch(`${remoteSettings.url}remoteSettings.url${query}`, {
	  //     method: 'POST',
	  //     headers: {
	  //       'Accept': 'application/json',
	  //       'Content-Type': 'application/json'
	  //     },
	  //     body: JSON.stringify(_errorData(e))
	  //   }).then(_checkStatus)
	  //     .then(_parseJSON)
	  //     .then((data) => remoteSettings.success(data))
	  //     .catch((error) => remoteSettings.error(error))
	  // }
	
	  var _errorData = function _errorData(e) {
	    var filename = e.filename.lastIndexOf('/');
	    return {
	      type: e.type,
	      path: e.filename,
	      filename: e.filename.substring(1 + filename),
	      line: e.lineno,
	      column: e.colno,
	      error: e.message,
	      stackTrace: e.error ? e.error.stack.toString().replace(/(\r\n|\n|\r)/gm, '') : '',
	      datetime: new Date().toString()
	    };
	  };
	
	  return {
	    init: init
	  };
	};
	
	module.exports = Loggrr();

/***/ }
/******/ ])
});
;
//# sourceMappingURL=loggrr.js.map